// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles-module__page--OHBhf{--homepage-content-width: 1140px}`, "",{"version":3,"sources":["webpack://./src/pages/Home/styles.module.scss"],"names":[],"mappings":"AAAA,4BACE,gCAAA","sourcesContent":[".page {\n  --homepage-content-width: 1140px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `styles-module__page--OHBhf`
};
export default ___CSS_LOADER_EXPORT___;
